import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// import { useDispatch } from 'react-redux';

// import { change } from 'redux-form';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import get from 'lodash/get';
import { Field, Flex, Button, Divider, Icon } from 'nallian-shared-ui/lib/components';
import { SelectFieldValueComponent } from 'nallian-shared-ui/lib/components/redux-form-semantic-ui';
import ReadOnlyFieldValueComponent from '../../../../app/components/ReadOnlyFieldValueComponent';

const PrincipalAppFeatureFlex = styled(Flex)`
  &&.ui.form .field,
  && .field,
  &&.field {
    margin-bottom: 0;
  }
`;

const RemoveFlex = styled(Flex)`
  position: relative;
  z-index: 1;
`;

const PrincipalAppRole = ({
  readOnly,
  editMode,
  index,
  field,
  fields,
  submitProcessing,
  handleRemoveFieldClick,
  features,
  app,
  // formName,
}) => {
  const { t } = useTranslation();
  // const dispatch = useDispatch();

  const value = useMemo(() => fields.get(index), [fields, index]);
  const isNew = Boolean(value?.isNew);

  const filteredFeatures = useMemo(
    () =>
      features.filter(f => {
        const exist = (app?.features || []).find(appFeature => appFeature.feature === f.value);
        return !exist || exist?.feature === value?.feature;
      }),
    [app, features, value]
  );

  const roleOptions = useMemo(
    () =>
      get(
        features.find(f => f.appInstallationFeature?.tag === value?.feature),
        'communityAppFeatureRoles',
        []
      ).map(cafr => ({
        key: cafr.appInstallationFeatureRole?.tag,
        value: cafr.appInstallationFeatureRole?.tag,
        text: cafr.alias || cafr.appInstallationFeatureRole?.name,
      })),
    [features, value]
  );

  // useEffect(() => {
  // if (value.isNew) {
  // dispatch(change(formName || 'principalForm', `${field}.roles`, []));
  // }
  // }, [value.isNew, value.feature, dispatch, field, formName]);

  return (
    <Flex fluid direction="column">
      <PrincipalAppFeatureFlex fluid alignItems="flex-start">
        <Field
          fluid
          search
          label={t('feature')}
          name={`${field}.feature`}
          valueComponent={
            (editMode && !isNew) || readOnly
              ? ReadOnlyFieldValueComponent
              : SelectFieldValueComponent
          }
          options={filteredFeatures}
          disabled={submitProcessing}
        />
        <Flex margin="0 0.5rem" />
        {!value?.feature ? (
          <Flex margin="2.2rem 0 0" fluid>
            <Flex>
              <Icon name="angle right" />
            </Flex>
            <Flex>{t('firstSelectAFeature')}</Flex>
          </Flex>
        ) : (
          <Field
            fluid
            search
            label={t('roles')}
            name={`${field}.roles`}
            valueComponent={readOnly ? ReadOnlyFieldValueComponent : SelectFieldValueComponent}
            multiple
            options={roleOptions}
            disabled={submitProcessing}
          />
        )}
        {!readOnly && value?.feature && (
          <RemoveFlex direction="column" alignItems="flex-end" margin="2.1rem -2.3rem 0 0.7rem">
            <Button
              linkbutton
              icon="close"
              type="button"
              tabindex="-1"
              i={index}
              onClick={handleRemoveFieldClick}
            />
          </RemoveFlex>
        )}
      </PrincipalAppFeatureFlex>
      {index < fields.length - 1 && <Divider />}
    </Flex>
  );
};

PrincipalAppRole.propTypes = {
  app: PropTypes.object.isRequired,
  readOnly: PropTypes.bool.isRequired,
  editMode: PropTypes.bool.isRequired,
  features: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired,
  fields: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
  submitProcessing: PropTypes.bool.isRequired,
  handleRemoveFieldClick: PropTypes.func.isRequired,
  formName: PropTypes.string,
};

PrincipalAppRole.defaultProps = { formName: undefined };

export default PrincipalAppRole;
